<template>
  <div class="contentBox" :class="device=='mobile'?'mobileBox':''" v-loading="loading" :element-loading-text="loadTxt">
    <button class="btn btn-back" @click="goBack"></button>
    <web ref="web"></web>
    <p class="title">{{listData.ai_comment?'AI点评':'请进行错题复盘练习'}}</p>
    <p class="msg" v-if="!listData.ai_comment">请回忆AI习题讲解，通过语音形式把这道错题的解题过程重新讲一遍</p>
    <div class="detail" v-if="!listData.ai_comment">
      <div class="detail-left">
        <div class="detail-item">
          <div class="detail-txt">
              <p class="txt">{{listData.content}}</p>
          </div>
        </div>
      </div>
      <div class="detail-right">
        <div class="bg">
          <img src="./../../src/assets/images/progress.gif" alt="" v-if="audioStatus">
          <div class="btnBox">
            <button class="btn btn-stop" v-if="audioStatus" @click="stopRecording"></button>
            <button class="btn btn-play" v-else @click="startRecording"></button>
          </div>
        </div>
      </div>
      <button class="btn btn-sub" @click="btnSub">提交并查看点评</button>
    </div>
    <div class="comment" v-else>
      <div class="comment-item">
        <p class="comment-title">我的录音:</p>
        <button class="btn btn-audio" @click="audioPLay">{{audioStatusTxt}}</button>
      </div>
      <div class="comment-item">
        <p class="comment-title">AI点评:</p>
        <button class="btn btn-audio" @click="aiPlay">{{aiStatusTxt}}</button>
        <div class="comment-txt" v-if="listData.ai_comment">{{listData.ai_comment}}</div>
        <div class="comment-load" v-else>
          <div class="comment-loading"></div>
          <button class="btn btn-new btn-sub" @click="againSub">重新加载AI</button>
        </div>
      </div>
      <div class="comment-item" v-if="listData.teacher_comment">
        <p class="comment-title">老师点评:</p>
        <div class="comment-txt">{{listData.teacher_comment}}</div>
      </div>
    </div>
    <audio src="" ref="audio" style="display: none;" @ended="audoEnd"></audio>
  </div>
</template>
<script>
// import IatRecorder from "@/assets/js/IatRecorder";
import IatRecorder from "../../static/IatRecorder";
const iatRecorder = new IatRecorder();
import { getReadWrongTopicDetail,addReadWrongTopic ,refreshWrongTopicComment} from "@/assets/js/api";
import web from './../components/comment/web.vue';
import axios from "axios"
import { ref } from 'vue';
const audioChunks = ref([]);
const audioBlob = ref(null);
const mediaRecorder = ref(null);
export default {
  name: "login",
  data() {
    return {
      dataObj:{
        rmid:'',
        rpid:'',
        num:'',
      },
      listData:[],
      uploadObj:{},
      commentObj:{
        rmid:'',
        rpid:'',
        audio:'',
        audio_txt:''
      },
      audioStatus:false,
      device:'',
      loading:false,
      loadTxt:'',
      isSub:false,
      audioStatusTxt:'播放录音',
      aiStatusTxt:'播放AI点评',
      audioType:''
    };
  },
  components: {
    web
  },
  mounted(){
    document.title = '错题讲解练习'
    var userData = JSON.parse(localStorage.getItem('identityData'));
    this.token = userData.apiToken;
    this.num = this.$route.query.num;
    this.dataObj = {
      rmid:this.$route.query.rmid,
      rpid:this.$route.query.rpid,
      num:this.$route.query.num,
    }
    this.getDetail();
    this.getToken();
    this.device = this.$refs.web.device;
    if(this.device == 'mobile'){
      this.$refs.web.font_resize();
    };
    window.speechSynthesis.cancel();
  },
  methods: {
    getToken(){
      var that = this;
      var url = this.$refs.web.url;
      axios({
        url:url+'/api/upload/getUploadToken',
        method:'post', 
      }).then((arr) => {
        if(arr.data.code == 200){
          that.uploadObj.token = arr.data.data.token
        } else {
          that.$message(arr.data.msg);
        }
        console.log(that.uploadObj);
      })
      .catch((error) => {
        console.log(error);
      });
    },

    async getDetail(){
      var that = this;
      try {
        const response = await getReadWrongTopicDetail({rmid:this.dataObj.rmid,rpid:this.dataObj.rpid},this.token);
        if(response.code == 200){
          that.listData = response.data;
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    async startRecording(){
      var that = this;
      if(this.isSub){
        this.$message('录音准备中，请勿重复点击')
        return false;
      }
      this.isSub = true;
      try {
        const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
        mediaRecorder.value = new MediaRecorder(stream);
        
        mediaRecorder.value.ondataavailable = (e) => {
          if (e.data.size > 0) audioChunks.value.push(e.data);
        };
        
        mediaRecorder.value.onstop = () => {
          // 生成WAV格式音频文件
          audioBlob.value = new Blob(audioChunks.value, { type: 'audio/mp3' });
          console.log(audioBlob.value,'==audioBlob.value==')
          that.uploadObj.file = audioBlob.value;
          that.uploadObj.key = new Date().getTime() +'.mp3'
          axios({
            url:'https://upload.qiniup.com',
            data:that.uploadObj,
            method:'post', 
            headers: { 
              'Content-Type': 'multipart/form-data' // 必须设置
            }
          }).then((arr) => {
            that.commentObj.audio = arr.data.key;
            console.log( that.commentObj,' that.commentObj')
          })
          .catch((error) => {
            console.log(error);
          });
        };
        mediaRecorder.value.start();
        iatRecorder.start();
        that.audioType = setInterval(function(){
          console.log(iatRecorder.status,'ssssss');
          if(iatRecorder.status == 'end'){
            // clearInterval(time)
            // that.stopRecording();
            iatRecorder.stop();
            setTimeout(function(){
              that.commentObj.audio_txt = that.commentObj.audio_txt+iatRecorder.resultText;
              iatRecorder.start();
            },1000)
          }
        },1000)
        that.audioStatus = true;
      } catch (error) {
        console.error("录音权限获取失败:", error);
      }
    },

    stopRecording(){
      if (mediaRecorder.value) {
        mediaRecorder.value.stop();
        mediaRecorder.value.stream.getTracks().forEach(track => track.stop());
      }
      iatRecorder.stop();
      // this.commentObj.audio_txt = iatRecorder.resultText;
      this.commentObj.audio_txt = this.commentObj.audio_txt+iatRecorder.resultText;
      this.audioStatus = false;
      this.isSub = false;
      clearInterval(this.audioType)
      console.log(iatRecorder)
    },

    async againSub(){
      var that = this;
      try {
        const response = await refreshWrongTopicComment({uvid:this.listData.uvid},this.token);
        if(response.code == 200){
          that.listData.ai_comment = response.data.answer;
          that.$forceUpdate();
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    async btnSub(){
      var that = this;
      this.commentObj.rmid = this.dataObj.rmid;
      this.commentObj.rpid = this.dataObj.rpid;
      if(this.commentObj.audio == ''){
        that.$message('还未完成录音！');
        return false;
      }
      this.loading = true;
      this.loadTxt = 'ai生成中...'
      try {
        const response = await addReadWrongTopic(this.commentObj,this.token);
        if(response.code == 200){
          that.listData.ai_comment = response.data.answer;
          that.$forceUpdate();
        } else {
          that.$message(response.msg);
        }
        that.loading = false;
        that.loadTxt = ''
      } catch (error) {
        that.$message(error);
        that.loading = false;
      }
    },

    goBack() {
      var that = this;
      that.$router.go(-1);
      window.speechSynthesis.cancel();
      setTimeout(function(){
        window.location.reload();
      },100)
    },

    audioPLay(){
      var that = this;
      window.speechSynthesis.cancel();
      that.aiStatusTxt = '播放AI点评';
      if(this.audioStatusTxt == '播放中'){
        return false;
      }
      that.$refs.audio.src = 'https://pic.bi-rong.com/' + this.commentObj.audio;
      that.$refs.audio.play();
      this.audioStatusTxt = '播放中';
    },

    audoEnd(){
      this.audioStatusTxt = '播放录音'
    },

    aiPlay(){
      var that = this;
      that.$refs.audio.pause();
      that.audoEnd();
      if(this.aiStatusTxt == '播放中'){
        return false;
      }
      if ('speechSynthesis' in window) {
          // let instance = new SpeechSynthesisUtterance();
          // console.log(window.speechSynthesis.getVoices())
          // instance.text = '轻轻敲醒沉睡的心灵，慢慢张开你的眼睛，看看忙碌的世界，是否依然孤独的转个不停！'; // 文字内容
          // instance.lang = "zh-CN"; // 使用的语言:中文
          // instance.volume = 1; // 声音音量：1
          // instance.rate = 1; // 语速：1
          // instance.pitch = 1; // 音高：1
          // window.speechSynthesis.speak(instance); // 播放
          // instance.addEventListener("end", () => {});// 监听播报完成状态，播完可以做些其它处理  
          const utterance = new SpeechSynthesisUtterance();
          utterance.volume  = 1
          utterance.text = that.listData.ai_comment;
          utterance.onend = () => {
            console.log("语音播报结束");
            that.aiStatusTxt = '播放AI点评';
          }
          utterance.onerror = (res) => {
            console.log(res)
          }
          utterance.onstart = (res) => {
            console.log(res,'sart')
          }
          speechSynthesis.speak(utterance);
          that.aiStatusTxt = '播放中';
      } else {
        alert('浏览器不支持语音合成');
      }
      
    },
  },

  
};
</script>
<style scoped>
  .contentBox{
    width: 100%;
    height: 100%;
    padding: 101px 0 75px;
    background-color: #F8F9FC;
  }

  .title{
    color: #333333;
    font-size: 40px;
    display: block;
    font-weight: bold;
    text-align: center;
  }

  .btn-back{
    background-image: url(~@/assets/images/btn-bg1.png);
  }

  .msg{
    font-size: 30px;
    margin: 10px 52px;
    color: #333333;
    display: block;
    text-align: center;
  }

  .detail{
    height: calc( 100% - 200px );
    display: block;
    font-size: 0;
  }

  .detail .detail-right,
  .detail .detail-left{
    width: 50%;
    display: inline-block;
    vertical-align: top;
    box-sizing: border-box;
    padding: 10px 20px;
  }

  .detail .detail-left{
    overflow-y: auto;
    overflow-x: hidden;
    height: 100%;
  }

  .detail-right .bg{
    background-image: url(~@/assets/images/audio-bg.png);
    width: 800px;
    height: 440px;
    background-size: 800px 440px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }

  .detail-right .bg img{
    width: 583px;
    height: 90px;
    display: block;
    margin: 46px auto 55px;
  }

  .detail-right .bg .btnBox{
    display: block;
    text-align: center;
  }

  .detail-right .bg .btn{
    width: 124px;
    height: 161px;
    background-size: 124px 161px;
    display: inline-block;
    vertical-align: top;
    margin-right: 50px;
  }

  .detail-right .bg .btn.btn-play{
    background-image: url(~@/assets/images/icon8.png);
  }
  .detail-right .bg .btn.btn-pause{
    background-image: url(~@/assets/images/icon9.png);
  }
  .detail-right .bg .btn.btn-stop{
    background-image: url(~@/assets/images/icon9.png);
  }

  .detail-item{
    margin-top: 20px;
    padding: 0 80px;
    box-sizing: border-box;
    display: block;
  }

  .detail-title{
    font-size: 32px;
    color: #333333;
  }

  .detail-title::before{
    content: '';
    width: 8px;
    height: 40px;
    background-color: #6098F2;
    display: inline-block;
    vertical-align: top;
    margin-right: 10px;
  }

  .detail-txt{
    display: block;
    margin-top: 10px;
    font-size: 0;
  }

  .detail-txt .txt{
    background-color: #F7F9FA;
    border-radius: 6px;
    font-size: 22px;
    color: #000000;
    box-sizing: border-box;
    padding: 20px;
    white-space: pre-line;
  }

  .btn-sub{
    font-size: 32px;
    color: #fff;
    padding: 15px 61px;
    border-radius: 60px;
    background-color: #6098F2;
    display: block;
    margin: 20px auto 0;
  }


  .comment{
    padding: 0 50px;
    box-sizing: border-box;
    height: 90%;
    overflow-x: hidden;
    overflow-y: auto;
  }

  .comment-item{
    margin-top: 30px;
  }

  .comment-title{
    font-size: 32px;
    color: #333333;
    display: inline-block;
    vertical-align: top;
  }

  .comment-title::before{
    content: '';
    width: 8px;
    height: 40px;
    background-color: #6098F2;
    display: inline-block;
    vertical-align: top;
    margin-right: 10px;
  }
  
  .comment-txt{
     display: inline-block;
    vertical-align: top;
    width: 80%;
    background-color: #EDEDED;
    border-radius: 6px;
    font-size: 22px;
    color: #333333;
    padding: 20px 30px;
    box-sizing: border-box;
    margin: 15px 0 0 100px;
  }

  .comment-load{
    text-align: center;
    display: inline-block;
    vertical-align: top;
  }

  .comment-loading{
    background-image: url(~@/assets/images/icon11.png);
    width: 519px;
    height: 374px;
    background-size: 519px 374px;
  }

   .btn-audio{
    font-size: 22px;
    color: #FFFFFF;
    background-color: #6098F2;
    border-radius: 6px;
    padding: 12px 15px;
    display: block;
    margin: 20px 0 0 100px;
  }

  .mobileBox .btn-back{
    height: .52rem;
    width: .52rem;
    background-size: .52rem .52rem;
  }

  .mobileBox .title{
    font-size: .3rem;
  }

  .mobileBox .msg{
    font-size: .24rem;
  }

  .mobileBox .detail-title{
    font-size: .24rem;
  }

  .mobileBox .detail-txt .txt{
    font-size: .18rem;
  }

  .mobileBox .detail-right .bg{
    width: 100%;
    height: 2.27rem;
    background-size: 100% 2.27rem ;
  }

  .mobileBox .detail-right .bg img{
    width: 100%;
    height: auto;
    margin: .1rem auto;
  }

  .mobileBox .detail-item{
    padding: 0;
  }

  .mobileBox .detail{
    height: calc( 100% - 1.2rem );
  }

  @media screen and (max-width: 1600px){
    .contentBox{
      padding: 20px 0;
    }

    .detail{
      height: calc( 100% - 240px );
    }

    .detail-right .bg{
      width: 100%;
    }
  }
</style>






// WEBPACK FOOTER //
// src/identity/wrongTopic.vue